initializeFeatureTabs();

function initializeFeatureTabs() {
  let featureTabsLink = document.querySelectorAll('.feature-tabs .nav-link');

  featureTabsLink.forEach(function (tab) {
    tab.addEventListener('show.bs.tab', function (e) {
      var featureTabs = tab.closest('.feature-tabs');

      if (e.target.classList.contains('has-video')) {
        var targetTabCover = featureTabs.querySelector(
          '.tab-cover-bg[data-tabpanel="' + e.target.getAttribute('href') + '"]'
        );
        var targetTabVideo = targetTabCover.getElementsByTagName('video');
        targetTabVideo[0].play();
      }
      if (e.relatedTarget.classList.contains('has-video')) {
        var targetTabCover = featureTabs.querySelector(
          '.tab-cover-bg[data-tabpanel="' + e.relatedTarget.getAttribute('href') + '"]'
        );
        var targetTabVideo = targetTabCover.getElementsByTagName('video');
        targetTabVideo[0].pause();
      }
    });
  });
}

export { initializeFeatureTabs };
